<div class="container-fluid">

  <div class="row">
    <div class="col-md-12">
    <div class="oi-comen-heading">
      <div class="row">
        <div class="col-md-12">
        <div class="faq-heading-bread">
          <u (click)="navigateTosavedanswer()">{{selectedcollection}} </u> <i class="bi bi-chevron-right"></i> 
          <span class="oi-h-link1" *ngIf="og_question || OriginalQnId"> Canonical Entry:</span>
           <span class="oi-h-link2" *ngIf="OriginalQnId"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M9 15l6 -6" /><path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" /><path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" /></svg>
             {{question}}
          </span>
          <span class="oi-h-link2" *ngIf="og_question"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M9 15l6 -6" /><path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" /><path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" /></svg>
             {{og_question}}
          </span>
        </div>
        </div>
        
      </div>

    </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <ng-container *ngIf="loader ">
        <div class="imgloader" *ngIf="loader">
          <img src="../../assets/img/loader.gif">
        </div>
      </ng-container >




      <div class="oi-faq-details-mn">
        <div class="row">

          <div class="col-md-8">

            <ng-container *ngIf="OriginalQnId; else originalQues"><div class="oi-asked-txt"> You asked: {{askedQN}} </div></ng-container>
            <ng-template #originalQues><div class="oi-asked-txt">You asked: {{og_question}} </div></ng-template>
            <div class="faq-dt-mn1">
              <div class="faq-dt-qns-top1">
                <div class="oi-faq-ans-brief">
                  <label *ngIf="isEditMode" class="fq-qa-label">Question</label>
                  <textarea class="oi-fq-qns-edit" *ngIf="isEditMode" [(ngModel)]="question"></textarea>
                  <div class="oi-faq-qns-detail" *ngIf="!isEditMode" [innerHTML]="sanitizeMessage(question)"></div>
                  <label *ngIf="isEditMode" class="fq-qa-label mt-2">Answer</label>
                  <textarea class="oi-fq-ans-edit" *ngIf="isEditMode" [(ngModel)]="answer"></textarea>
                  <div class="oi-faq-ans-detail" *ngIf="!isEditMode" [innerHTML]="sanitizeMessage(answer)"></div>
                </div>

                <div class="oi-qns-detail-like-downl">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="oi-tag-container">
                        <div *ngFor="let doc of getFilteredDocuments()" class="tag" (click)="navigateToDoc(doc)">{{ doc.document_name }}</div>
                      </div>       
                    </div>
                    <div class="col-md-6">
                      <div class="oi-qns-det-like-btn">
                        <div class="like-btn">
                            <button type="button" class="btn btn-primary like" (click)="thumbsup()">
                                <img src="../../assets/img/{{thumbsupClicked?'thumb-up-active' : 'thumb-up'}}.svg">
                            </button>
                            <span>{{ likeCounts[questionId] || 0 }}</span>
                        </div>
                        <div class="like-btn">
                            <button type="button" class="btn btn-primary dislike" (click)="thumbsdown()">
                                <img src="../../assets/img/{{thumbsdownClicked?'thumb-down-active' : 'thumb-down'}}.svg">
                            </button>
                            <span>{{ dislikeCounts[questionId] || 0 }}</span>
                        </div>                                        
                    </div>
                    </div>
                    <div class="col-md-6">
                      <div class="oi-faq-dtl-mn">        
                        <div class="oi-qns-edit-save-btn oi-qnsans-ask-again-all">
                          <button type="button" class="btn"  pTooltip="Remap" (click)="OpentomapAnswer()"><img src="../assets/img/remap.svg"></button>

                          <button type="button" class="btn" pTooltip="Edit"  (click)="editQues()"><img src="../../assets/img/edit.svg"></button>
                          <button type="button" class="btn ansdownld dislike"  pTooltip="Answer" *ngIf="!isEditMode && role=='admin'" (click)="downloadAnswer(answer)">
                            <img src="../../assets/img/download.svg"></button>
                          <button type="button" class="btn btn-primary cancel" *ngIf="isEditMode" (click)="cancelChange()">Cancel</button>
                          <button type="button" class="btn btn-primary save" *ngIf="isEditMode" (click)="savechanges()">Save</button>
                        </div>
                        
    
                      </div> 
                    </div>
    
                  </div>
                </div>
                <ng-container *ngIf="loader else showcontent">
                  <div class="imgloader" *ngIf="loader">
                    <img src="../../assets/img/loader.gif">
                  </div>
                </ng-container>

                <ng-template #showcontent>
                  <div class="" *ngIf="similarQuestions else noresult">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="oi-sim-mn1"  *ngIf="similarQuestions.length>0">
                          <h3>Other Questions mapped to this Q&A</h3>
                          <div  >
                            <div class="oi-faq-similr-box">

                              <div class="oi-faq-qns-table">
                                <table class="table">
                                  <tr>
                                    <th>Question</th>
                                    <th>Answer</th>
                                    <th>Date</th>
                                    <th class="actcenter">Action</th>
                                  </tr>
                                  <tr *ngFor="let question of similarQuestions,let i=index ">
                                    <td [innerHTML]="sanitizeMessage(question.question)" class="faq-text1" *ngIf="!question.isotherQnEditMode"></td>
                                    <td *ngIf="question.isotherQnEditMode"><textarea class="faq-edit-txt" [(ngModel)]="question.question"></textarea></td>
                                    <td [innerHTML]="sanitizeMessage(question.answer)" class="faq-text1" ></td>

                                    <td class="faq-date-1" width="20%">{{question.updated_at | customDate}}</td>
                                    <td class="faq-icon-edt" width="28%" align="center">
                                      <i class="fa fa-edit" (click)="editotherQn(i)"  pTooltip="Edit" *ngIf="!question.isotherQnEditMode"> </i>
                                      <i class="fa fa-check-circle edt-check1" (click)="updatemapQn(question)"  pTooltip="save" *ngIf="question.isotherQnEditMode"></i>  
                                      <i class="fa fa-times-circle edt-cancel1"  (click)="cancelEditQn(i)"  pTooltip="cancel" *ngIf="question.isotherQnEditMode"></i>
                                    
                                    <div class="use-btn-mn-faq"><button class="usen1" (click)="useThisAnswer(question)">Use This Answer</button></div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              
                              <!-- <div class="oi-simlr-qns d-flex justify-content-between"> <span class="text" [innerHTML]="sanitizeMessage(question.question)"></span> <span class="date">28 July 2024</span></div>
                              <div class="oi-simlr-ans" [innerHTML]="sanitizeMessage(question.answer)"></div> -->
              
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="similarQuestions.length>0">
                    <p-paginator (onPageChange)="onPageChange($event)"
                      [first]="first" [rows]="rows" [totalRecords]="totalrecords"
                      ></p-paginator>
                  </div>
                  <ng-template #noresult>
                    <div class="oi-no-resultfound">
                      <img src="../../assets/img/no-result.png">
                      <h3>Sorry! No result found :(</h3>
                      <p>We're sorry what you were looking for. Please try another way</p>
                    </div>
                  </ng-template>
                </ng-template>

                
              </div>

              <div class="faq-dt-qns-bottom1"></div>

            </div>

          </div>

          <div class="col-md-4 faq-left-border">
          <div class="oi-faq-det-related">
            <h3>Answer Versions</h3>
            <div class="oi-faq-related-qns">
            <ul  *ngIf="topratedQuestion?.length > 0; else noQuestions">
            <li *ngFor="let data of topratedQuestion" ><a [innerHTML]="sanitizeMessage(data.answer)"></a>
           <button class="use-ans-btn1" (click)="useThisAnswer(data)">Use this answer</button>
            </li>
            </ul>
             <ng-template #noQuestions>
             <p>No Answer Versions available.</p>
            </ng-template>
            </div>

          </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="showmodal" [header]="dialogheader" [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onDialogHideaddcollection()">
    <div class="oi-ad-collect-mdl khdoc">
        <ng-container *ngIf="modalloader else showdata">
            <div class="imgloader">
                <img src="../../assets/img/loader.gif">
            </div>
        </ng-container>
        <ng-template #showdata>
            <div class="modal-content documnttext">
            <div class="oi-map-modal">
                <div class="oi-qns-mn" [innerHTML]="sanitizeMessage(mappedQuestion)"></div>
                <div class="oi-ans-mn" [innerHTML]="sanitizeMessage(mappedAnswer)"></div>
                <div class="oi-qns-mdl-sear-mn">
                <h1>Correct Answer</h1>
                <div class="oi-map-ans-search">
                    <div class="oi-qns-ans-search-mn d-flex justify-content-start">
                        <div class="oi-qns-ans-search-top">
                            <p-autoComplete [(ngModel)]="searchkey" [suggestions]="filteredQuestions" 
                            (completeMethod)="mapsearch($event)"   (onSelect)="onSelectmap($event)"
                            (keyup.enter)="performmapSearch()"  field="question" placeholder="Type your question here..." 
                              >
                            <ng-template let-question pTemplate="item">
                                <div [innerHTML]="question.question | highlight:searchkey"></div>
                              </ng-template>
                        </p-autoComplete>
                        </div>
                        <div class="oi-qns-ans-btn-top"><button type="button" class="btn btn-primary" (click)="performmapSearch()"><img src="../../assets/img/search1.svg"></button></div>
                    </div>
                </div> 
                <ng-container *ngIf="maploader else showAnswertempate">
                    <div class="imgloader" *ngIf="loader">
                      <img src="../../assets/img/loader.gif">
                    </div>
                  </ng-container >
                <ng-template #showAnswertempate>
                <div class="oi-qns-ans-txtmn" *ngIf="correctanswer" >
                    <div class="oi-qns-mn-map1" [innerHTML]="sanitizeMessage(correctanswer)"></div>
                </div>
            </ng-template>
                <div class="oi-map-bottom-btn">
                    <button type="button" class="btn btn-closed" (click)="Onclose()">Close</button>
                    <button type="button" class="btn btn-map" (click)="mapAnswer()">Map</button>
                </div>

                </div>

            </div>
            </div>
        </ng-template>
    </div>

</p-dialog>
<p-toast></p-toast>



  